import openSaveDB from "./openSaveDB";

import { jsdos_save_store_name } from "./constants";

export default async function (key) {
  const db = await openSaveDB();
  await db.delete(jsdos_save_store_name, key);
  db.close();
}
